import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const calorClaimsManagementRoute: RouteConfig<'with-page'> = {
    name: 'Claims',
    path: '/calor/claims',
    page: lazy(() => import('.')),
    roles: ['calorClaimsEmployee'],
}